/**
 * Zod schema for the `emailDeliveries` collection.
 *
 * Per-recipient delivery tracking for notification + invitation emails.
 * Created by Cloud Functions; read-only by per-event organizers/admins.
 * Exactly one of `notificationId` or `invitationId` is non-null.
 */

import { z } from 'zod';
import type { TimestampLike } from '../types/common';

/** `suppressed` = SUPPRESS_EMAILS was on at send time; no mail doc exists. */
export const emailDeliveryStatusSchema = z.enum([
  'queued',
  'sent',
  'failed',
  'bounced',
  'suppressed',
]);

export const emailDeliveryDocumentSchema = z.object({
  /** Non-null for notification emails. */
  notificationId: z.string().nullable(),
  /** Non-null for invitation emails. */
  invitationId: z.string().nullable(),
  eventId: z.string(),
  /** Recipient user ID. Null for invitation emails (no account yet). */
  userId: z.string().nullable(),
  /** Snapshot of recipient email at send time. */
  email: z.string(),
  status: emailDeliveryStatusSchema,
  sentAt: z.custom<TimestampLike>().nullable(),
  error: z.string().nullable(),
});
